module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("41tij"))).then(() => parcelRequire('fThBo'));